import BadName from './modules/index'

import constants from './modules/constants/index'

class Sketch {
  constructor(svg) {
    let bn = new BadName(svg)
    , proxyMethods = [
      // background
      "changeMatrix",
      "blur",

      // shape 
      "addShape",
      "createShape",
      "updateShape",
      "removeShape",
      "focusShape",

      // line 
      "addLine",
      "createLine",
      "updateLine",
      "removeLine",
      "focusLine",

      // point 
      "focusPoint",
      "removePoint",

      // others
      "beforeCreateShape",
      "zoomDefault",
      "zoomIn",
      "zoomOut",
      "destroy",
      "on",
      "off",

      "applyDefault",
      "clear",

      "select",
      "selectAll",

      "setColor",

      "requestAutoScroll",
      "cancelAutoScroll"
    ]
    , proxyValues = [
      "matrix",
      "data",
      "dirty",
      "mode",
      "typeNameVisible",
      "tool"
    ]

    for (let i = 0; i < proxyMethods.length; i ++) {
      this[proxyMethods[i]] = bn[proxyMethods[i]].bind(bn)
    }

    for (let i = 0; i < proxyValues.length; i ++) {
      Object.defineProperty(this, proxyValues[i], {
        get() {
          return bn[proxyValues[i]]
        },
        set(v) {
          bn[proxyValues[i]] = v
        }
      })
    }
  }
}

Sketch.HandTool = constants.tools.hand
Sketch.MarqueeTool = constants.tools.marquee

if (typeof window !== "undefined") {
  // @ts-ignore
  window.Sketch = Sketch
}

export default Sketch


// WEBPACK FOOTER //
// ./src/common/components/process-editor/index.js